import { Base } from "../Base";
import { Restriction } from "./Restriction";
export class Class extends Base {
    allowed;
    class = "string";
    name = "string";
    get definition() {
        return Object.assign(super.definition, this.allowed === undefined ? {} : { allowed: this.allowed });
    }
    constructor(allowed) {
        super();
        this.allowed = allowed;
    }
    is(value) {
        return typeof value == "string";
    }
    restrict(...restriction) {
        return super.restrict(...(Base.Restriction.is(restriction) ? restriction : Restriction.convert(restriction)));
    }
    static create(...restriction) {
        const result = new Class(restriction[0] == "value" ? restriction.slice(1) : undefined);
        return ((value) => Array.isArray(value) && value.length == 0)(restriction)
            ? result
            : result.restrict(...restriction);
    }
}
//# sourceMappingURL=Class.js.map